import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  private readonly _pendingRequests = signal(0);
  readonly isLoading = computed(() => this._pendingRequests() > 0);

  increment(): void {
    this._pendingRequests.update((n) => n + 1);
  }

  decrement(): void {
    this._pendingRequests.update((n) => Math.max(0, n - 1));
  }
}
